import React from 'react';

import ArrowDropDownRoundedIcon from '@material-ui/icons/ArrowDropDownRounded';
import CloseIcon from '@material-ui/icons/Close';
import { ItemContainer } from 'screens/Team/TeamPageFilters/styles';
import styled from 'styled-components';
import { StyledTypography, VerticallyCenterContainer } from 'styles/common';

import { StyledIcon } from 'constants/icons';

import { SelectedCounter } from './styles';

const FilterDisplay = React.forwardRef((props, ref) => {
  const { width, onClick, icon, name, selectedCount, className, isDisabled = false, removeFilters } = props;
  return (
    <ItemContainer
      className={className}
      width={width}
      justify="space-between"
      ref={ref}
      onClick={onClick}
      disabled={isDisabled}
    >
      {
        // <StyledTooltip title={<div>{name}</div>} component="span">
      }
      <VerticallyCenterContainer container alignItems="center" style={{ overflow: 'hidden' }}>
        {icon && (
          <StyledIcon color="textSecondary" size="smallest">
            {icon}
          </StyledIcon>
        )}
        <StyledTypography noWrap leftGutter={1} variant="body2" display="inline">
          {name}
        </StyledTypography>
      </VerticallyCenterContainer>
      {
        // </StyledTooltip>
      }

      <VerticallyCenterContainer container alignItems="center">
        <SelectedCounter hiddenText={selectedCount === 0}> +{selectedCount}</SelectedCounter>
        {selectedCount === 0 ? (
          <StyledIcon leftGutter={0.3} rightGutter={-1} size="smallest" color="textSecondary">
            <ArrowDropDownRoundedIcon style={{ width: '24px' }} />
          </StyledIcon>
        ) : (
          <StyledIcon leftGutter={0.3} rightGutter={-1} size="smallest" color="textSecondary" onClick={removeFilters}>
            <StyledCloseIcon />
          </StyledIcon>
        )}
      </VerticallyCenterContainer>
    </ItemContainer>
  );
});

const StyledCloseIcon = styled(CloseIcon)`
  width: 15px;
  fill: #666 !important;
  border-radius: 50%;
  border: 1px solid #999;
  background: white;
  cursor: pointer;
  height: 16px !important;
  margin: 0 5px;
  padding: 1px;
`;

export default FilterDisplay;
